import {
  Download,
  Sparkles,
  Trophy,
  Upload,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { AchievementDefinition } from '@/redux/achievement/achievement.types';

export interface AchievementCategory {
  key: string;
  label: string;
  icon: LucideIcon;
  match: RegExp;
}

// first match wins: community-builder must hit Community before Recognition
const ACHIEVEMENT_CATEGORIES: AchievementCategory[] = [
  {
    key: 'start',
    label: 'Getting started',
    icon: Sparkles,
    match:
      /^(welcome|first-download|profile-picture|add-website|add-social|complete-profile|following|filefinity-founder)$/,
  },
  {
    key: 'uploads',
    label: 'Uploads',
    icon: Upload,
    match:
      /^(first-upload|full-project|fresh-drop|share-file|uploads-|big-box-ready|perfect-project|upload-streak-)/,
  },
  {
    key: 'downloads',
    label: 'Downloads',
    icon: Download,
    match: /^(downloads-|one-file-|total-downloads-)/,
  },
  {
    key: 'community',
    label: 'Community',
    icon: Users,
    match:
      /^(first-follower|followers-|first-like|likes-|first-make|makes-|made-it|reviewer|helpful-maker|community-builder|super-fan|login-streak-)/,
  },
  {
    key: 'recognition',
    label: 'Recognition',
    icon: Trophy,
    match:
      /^(file-of-the-week|creator-of-the-month|featured-maker|community-|monthly-challenge|badges-)/,
  },
];

const FALLBACK: AchievementCategory = {
  key: 'more',
  label: 'More',
  icon: Trophy,
  match: /$^/,
};

export const categoryOf = (id: string) =>
  ACHIEVEMENT_CATEGORIES.find((category) => category.match.test(id)) ??
  FALLBACK;

export const groupByCategory = <T extends { entry: AchievementDefinition }>(
  rows: T[]
) => {
  const groups = new Map<
    string,
    { category: AchievementCategory; rows: T[] }
  >();
  rows.forEach((row) => {
    const category = categoryOf(row.entry.id);
    const group = groups.get(category.key) ?? { category, rows: [] };
    group.rows.push(row);
    groups.set(category.key, group);
  });
  return [...groups.values()];
};
